function documentationService($http, WCConstants, $window) {
    let vm = this;

    vm.fetchCategories = function () {
        return $http
            .get('myaccount://documentation/categories')
            .then(function (res) {
                return res.data.map((category) => {
                    category['documentations'] = category['documentations'].map((documentation) => {
                        documentation['preview_url'] = $window.location.origin + '/myaccount/api/documentation/preview/' + documentation.doc_id;
                        return documentation;
                    });
                    category['preview_url'] = $window.location.origin + '/myaccount/api/documentation_category/preview/' + category.cat_id;
                    return category;
                });
            })
            .catch(function () {
                return false;
            });
    };

    vm.getDocumentationURL = function (documentation) {
        if (documentation['doc_id'] === undefined) {
            return false;
        }
        return WCConstants.appConfig.servers['myaccount'] + 'documentation/file/' + String(documentation.doc_id);
    };

    return vm;
}

angular.module('app.portail.documentation').factory('documentationService', documentationService);
